/* eslint-disable consistent-return */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useWorkflow } from "../../../../../../context/WorkflowContext";

import GenericUtils from "../../../../../../utils/GenericUtils";
import { IActivityManagementWorkflow } from "../../../../../../context/interfaces/IWorkflowContext";
import TableStyles from "../../../../../../styles/components/TableStyles";
import DialogStyles from "../../../../../../styles/components/DialogStyles";
import ButtonStyles from "../../../../../../styles/components/ButtonStyles";
import { IActivities } from "../../../../interface/IActivities";
import TBody from "./TBody";
import ActivitiesManagementFormsStyles from "../../../../../../styles/pages/Workflows/ActivitiesManagementFormsStyles";
import PaginationLocal from "../../../../../../components/PaginationLocal";
import ActivityManagementWorkflowService from "../../../../../../service/Docente/ActivityManagementWorkflowService";

interface IModalProps {
    workflow: IActivityManagementWorkflow | null;
    handleChangeContent: (content: string) => void;
    changeModalTitle: (title: string) => void;
}

const { StyledContainerButton } = DialogStyles;
const { BtnPrimary } = ButtonStyles;

const NotPerformedActivities: React.FC<IModalProps> = ({
    workflow,
    handleChangeContent,
    changeModalTitle,
}) => {
    const { instance } = useMsal();
    const workflowContext = useWorkflow();
    const { processoId } = workflow || {};
    const { workflowTypeId } = workflowContext.workflowFilter || {};
    const [activitiesNotPerformed, setActivitiesNotPerformed] = useState<
        IActivities[]
    >([]);
    const [filteredActivitiesNotPerformed, setFilteredActivitiesNotPerformed] =
        useState<IActivities[]>([]);

    const getNotPerformedActivities = async () => {
        try {
            const getNotPerformedWorkflowResponse =
                await ActivityManagementWorkflowService.getNotPerformedWorkflow(
                    workflowTypeId,
                    processoId,
                    instance
                );

            if (
                GenericUtils.isSuccessStatus(
                    getNotPerformedWorkflowResponse.status
                )
            ) {
                const { cartoes } = getNotPerformedWorkflowResponse.data;
                return cartoes;
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    const handleNotPerformedActivities = async () => {
        changeModalTitle("Atividades Não Realizadas");
        const notPerformedActivities = await getNotPerformedActivities();

        setActivitiesNotPerformed(notPerformedActivities);
        setFilteredActivitiesNotPerformed(notPerformedActivities);
    };

    useEffect(() => {
        handleNotPerformedActivities();
    }, []);

    const listNotPerformedActivities = filteredActivitiesNotPerformed &&
        filteredActivitiesNotPerformed.length && (
            <TBody activities={filteredActivitiesNotPerformed} />
        );

    return (
        <>
            <p style={{ padding: "16px 0 40px 0" }}>
                Confira abaixo as atividades não realizadas.
            </p>
            {activitiesNotPerformed && activitiesNotPerformed.length ? (
                <>
                    <TableStyles.TablePrimary
                        bordered
                        striped
                        responsive
                        style={{ marginBottom: 0 }}
                    >
                        <thead>
                            <tr>
                                <th>Tipo do Cartão</th>
                                <th>Nome da Atividade</th>
                                <th>Data</th>
                                <th>Alocação</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>{listNotPerformedActivities}</tbody>
                    </TableStyles.TablePrimary>
                    <ActivitiesManagementFormsStyles.StyledPaginationContainer>
                        <PaginationLocal
                            items={activitiesNotPerformed}
                            itemsPage={10}
                            onPaginate={(activities) =>
                                setFilteredActivitiesNotPerformed(activities)
                            }
                            hidePagination={false}
                        />
                    </ActivitiesManagementFormsStyles.StyledPaginationContainer>
                </>
            ) : (
                <>
                    <p style={{ fontWeight: "bold" }}>
                        Não há atividades não realizadas neste período.
                    </p>
                    <p style={{ fontWeight: "bold" }}>
                        Você pode fechar esta tela ou voltar para visualizar
                        outros tipos de atividades.
                    </p>
                </>
            )}
            <StyledContainerButton>
                <BtnPrimary
                    style={{ width: 126, marginTop: 24 }}
                    onClick={() => handleChangeContent("PERFORMED")}
                >
                    Voltar
                </BtnPrimary>
            </StyledContainerButton>
        </>
    );
};

export default NotPerformedActivities;
